<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        :loading="loading"
        :title="`${id ? 'Edição' : 'Cadastro'} de alergia / reação adversa`"
        @save="$refs.Form.save()"
        ref="Modal"
    >
        <Form
            :id="id"
            @save="handleExit"
            ref="Form"
            layout="modal"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        id: null,
    }),
    methods: {
        open(id) {

            this.id = id

            this.$refs.Modal.show()
        },
        handleExit(alergia) {

            this.$emit('save', alergia);

            this.close()
        },
        close() {

            this.$refs.Modal.hide()
        },
    },
}
</script>